import { render, staticRenderFns } from "./DeleteExpiredPickls.vue?vue&type=template&id=509e5f9f&scoped=true&"
import script from "./DeleteExpiredPickls.vue?vue&type=script&lang=ts&"
export * from "./DeleteExpiredPickls.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteExpiredPickls.vue?vue&type=style&index=0&id=509e5f9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e5f9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509e5f9f')) {
      api.createRecord('509e5f9f', component.options)
    } else {
      api.reload('509e5f9f', component.options)
    }
    module.hot.accept("./DeleteExpiredPickls.vue?vue&type=template&id=509e5f9f&scoped=true&", function () {
      api.rerender('509e5f9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteExpiredPickls.vue"
export default component.exports